export default __webpack_public_path__ + "static/media/gallery_08.4a11cae4.jpg";